import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LiveStreamHero from "@/components/LiveStreamHero";
import AlertBanner from "@/components/AlertBanner";
import CityConditions from "@/components/CityConditions";
import WeatherImpact from "@/components/WeatherImpact";
import ForecastVideos from "@/components/ForecastVideos";
import ForecastArticle from "@/components/ForecastArticle";
import RadarSection from "@/components/RadarSection";
import TeamSection from "@/components/TeamSection";
import NewsletterCTA from "@/components/NewsletterCTA";
import BroadcastGraphics from "@/components/BroadcastGraphics";

export default function Home() {
  return (
    <div className="relative min-h-screen">
      <Header />
      <AlertBanner />
      <LiveStreamHero />
      <BroadcastGraphics />
      <ForecastArticle />
      <NewsletterCTA />
      <CityConditions />
      <WeatherImpact />
      <RadarSection />
      <ForecastVideos />
      <TeamSection />
      <Footer />
    </div>
  );
}
